<template>
  <div class="d-flex align-center justify-space-between">
    <span>{{label}}</span>
    <icon-button
    @click="$emit('remove')"
    :disabled="disabled"
    src="minus"
    color="red"/>
  </div>
</template>

<script>
import IconButton from '@/components/btns/IconButton'
export default {
  components: {
    IconButton
  },
  props: {
    label: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>

</style>